import { Typography, Container } from "@mui/material";
export const AvisLegalPage = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: "64px",
        mb: "64px",
      }}
    >
      <Typography variant="h3" sx={{ mb: 3 }}>
        Avís legal
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Aquest lloc web és propietat de BuscoPis, amb domicili a Andorra. L'ús
        d'aquest lloc web està subjecte als termes i condicions següents. Si us
        plau, llegeixi'ls atentament abans d'utilitzar-lo.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Propietat intel·lectual
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Tots els continguts d'aquest lloc web, incloent-hi textos, imatges,
        gràfics, logotips, icones, programari i altres materials, són propietat
        de BuscoPis o de tercers que han autoritzat el seu ús i estan protegits
        per les lleis de propietat intel·lectual.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Ús del lloc web
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        L'usuari es compromet a utilitzar aquest lloc web de manera lícita i
        respectuosa amb els drets de tercers. Queda prohibit l'ús del lloc web
        per a activitats il·legals, difamacions, o qualsevol acció que pugui
        danyar la imatge de BuscoPis.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Limitació de responsabilitat
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        BuscoPis no es fa responsable dels danys o perjudicis derivats de
        l'accés o ús d'aquest lloc web, incloent-hi errors o omissions en els
        continguts, interrupcions del servei o virus informàtics.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Modificacions
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        BuscoPis es reserva el dret de modificar en qualsevol moment i sense
        previ avís els continguts, termes i condicions d'aquest lloc web.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Legislació aplicable
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Aquest avís legal es regeix per la legislació vigent a Andorra.
        Qualsevol controvèrsia derivada de l'ús d'aquest lloc web serà sotmesa
        als tribunals competents d'Andorra.
      </Typography>
    </Container>
  );
};
